import LegalLayout from '../components/legal/LegalLayout';

export default function PrivacyPolicy() {
  return (
    <LegalLayout 
      title="Datenschutzerklärung" 
      lastUpdated="15. Februar 2026"
    >
      <section className="space-y-8">
        <div>
          <h2 className="text-2xl font-bold text-white mb-4">1. Datenschutz auf einen Blick</h2>
          
          <h3 className="text-xl font-semibold text-white mb-3">Allgemeine Hinweise</h3>
          <p className="text-gray-300 leading-relaxed mb-4">
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten 
            passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie 
            persönlich identifiziert werden können.
          </p>

          <h3 className="text-xl font-semibold text-white mb-3">Datenerfassung auf dieser Website</h3>
          <p className="text-gray-300 leading-relaxed mb-4">
            <strong className="text-white">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong>
            <br />
            Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten 
            können Sie dem Abschnitt „Hinweis zur verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.
          </p>

          <p className="text-gray-300 leading-relaxed mb-4">
            <strong className="text-white">Wie erfassen wir Ihre Daten?</strong>
            <br />
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um 
            Daten handeln, die Sie in ein Kontaktformular eingeben. Andere Daten werden automatisch oder nach Ihrer 
            Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst.
          </p>

          <p className="text-gray-300 leading-relaxed mb-4">
            <strong className="text-white">Wofür nutzen wir Ihre Daten?</strong>
            <br />
            Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. 
            Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden. Im Falle von Azrefy verarbeiten 
            wir Ihre Finanzdaten ausschließlich lokal auf Ihrem Gerät und übertragen diese nicht an unsere Server.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">2. Hosting</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
          </p>
          
          <h3 className="text-xl font-semibold text-white mb-3">Externes Hosting</h3>
          <p className="text-gray-300 leading-relaxed mb-4">
            Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden, 
            werden auf den Servern des Hosters / der Hoster gespeichert. Hierbei kann es sich v.a. um IP-Adressen, 
            Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe 
            und sonstige Daten, die über eine Website generiert werden, handeln.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">3. Allgemeine Hinweise und Pflichtinformationen</h2>
          
          <h3 className="text-xl font-semibold text-white mb-3">Datenschutz</h3>
          <p className="text-gray-300 leading-relaxed mb-4">
            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre 
            personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie 
            dieser Datenschutzerklärung.
          </p>

          <h3 className="text-xl font-semibold text-white mb-3">Hinweis zur verantwortlichen Stelle</h3>
          <p className="text-gray-300 leading-relaxed mb-4">
            Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
          </p>
          <div className="bg-gray-900 border border-gray-800 rounded-lg p-6 mb-4">
            <p className="text-gray-300">
              Azrefy<br />
              Freiburg im Breisgau<br />
              Deutschland<br />
              <br />
              E-Mail: hello@azrefy.com
            </p>
          </div>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">4. Datenerfassung auf dieser Website</h2>
          
          <h3 className="text-xl font-semibold text-white mb-3">Cookies</h3>
          <p className="text-gray-300 leading-relaxed mb-4">
            Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine Datenpakete und richten auf 
            Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung 
            (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert.
          </p>

          <h3 className="text-xl font-semibold text-white mb-3">Server-Log-Dateien</h3>
          <p className="text-gray-300 leading-relaxed mb-4">
            Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, 
            die Ihr Browser automatisch an uns übermittelt. Dies sind:
          </p>
          <ul className="list-disc list-inside text-gray-300 space-y-2 mb-4 ml-4">
            <li>Browsertyp und Browserversion</li>
            <li>verwendetes Betriebssystem</li>
            <li>Referrer URL</li>
            <li>Hostname des zugreifenden Rechners</li>
            <li>Uhrzeit der Serveranfrage</li>
            <li>IP-Adresse</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">5. Azrefy App - Finanzielle Datenverarbeitung</h2>
          
          <h3 className="text-xl font-semibold text-white mb-3">Lokale Datenverarbeitung</h3>
          <p className="text-gray-300 leading-relaxed mb-4">
            <strong className="text-white">Wichtig:</strong> Azrefy speichert und verarbeitet Ihre Finanzdaten 
            ausschließlich lokal auf Ihrem Gerät. Wir übertragen keine Kontoinformationen, Transaktionsdaten oder 
            Bankverbindungen an unsere Server.
          </p>

          <h3 className="text-xl font-semibold text-white mb-3">Bankverbindungen</h3>
          <p className="text-gray-300 leading-relaxed mb-4">
            Die Verbindung zu Ihrer Bank erfolgt über sichere, verschlüsselte Schnittstellen (PSD2-konform). 
            Ihre Banking-Zugangsdaten werden verschlüsselt auf Ihrem Gerät gespeichert und niemals an uns übertragen.
          </p>

          <h3 className="text-xl font-semibold text-white mb-3">KI-Analysen</h3>
          <p className="text-gray-300 leading-relaxed mb-4">
            Die KI-gestützten Analysen und Tipps werden lokal auf Ihrem Gerät durchgeführt. Wir sammeln keine 
            individuellen Finanzdaten für Trainingszwecke. Aggregierte, anonymisierte Nutzungsstatistiken können 
            für die Verbesserung des Service erhoben werden.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">6. Ihre Rechte</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            Sie haben jederzeit das Recht:
          </p>
          <ul className="list-disc list-inside text-gray-300 space-y-2 mb-4 ml-4">
            <li>Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten zu verlangen</li>
            <li>Die Berichtigung unrichtiger personenbezogener Daten zu verlangen</li>
            <li>Die Löschung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen</li>
            <li>Die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen</li>
            <li>Der Verarbeitung Ihrer personenbezogenen Daten zu widersprechen</li>
            <li>Sich bei einer Aufsichtsbehörde zu beschweren</li>
          </ul>
        </div>

        <div className="bg-blue-900/20 border border-blue-500/30 rounded-xl p-6">
          <p className="text-gray-300 leading-relaxed">
            <strong className="text-white">Kontakt bei Datenschutzfragen:</strong><br />
            Bei Fragen zum Datenschutz kontaktieren Sie uns bitte unter: hello@azrefy.com
          </p>
        </div>
      </section>
    </LegalLayout>
  );
}
